import { useState } from "react";
import Api from "../../service/Api";
import '../ForgotPassword/ForgotPassword.css';
import { useTranslation } from 'react-i18next'; 

function ForgotPassword() {
   const { t } = useTranslation();
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    Api.forgotpassword(email);
  };

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={handleSubmit}>
        <h2>{t('login-forgot-password1')}</h2>
        <p>{t('login-forgot-password2')}</p>

        <input
          type="email"
          placeholder={t('login-forgot-password3')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button type="submit">{t('login-forgot-password4')}</button>

        <div className="auth-link">
          <a href="/login">{t('login-forgot-password5')}</a>
        </div>
      </form>
    </div>
  );
}

export default ForgotPassword;